import { ColDef } from "@ag-grid-community/core";
import { clsx } from "clsx";
import { maybernCellErrorClass } from "shared/components/table/maybern/MaybernTableConstants";
import { getMaybernTableCellError } from "shared/components/table/maybern/MaybernTableErrors";
import { maybernTableSuppressKeyboardEventForInput } from "shared/components/table/maybern/MaybernTableSuppressKeyboardEventForInput";
import { isMaybernTableColumnLastInGroup } from "shared/components/table/maybern/MaybernTableUtils";

export const MaybernTableDefaultColDef: ColDef = {
  suppressKeyboardEvent: maybernTableSuppressKeyboardEventForInput,
  suppressHeaderMenuButton: true,
  headerClass: (params) =>
    clsx({
      "mb-header-last-in-group": isMaybernTableColumnLastInGroup(params),
      "mb-header-has-title": Boolean(params.colDef.headerName),
    }),
  cellClassRules: {
    "mb-cell-last-in-group": (params) =>
      isMaybernTableColumnLastInGroup(params),
    [maybernCellErrorClass]: (params) =>
      Boolean(getMaybernTableCellError(params)),
  },
};
